var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visbile
    ? _c(
        "div",
        { staticClass: "wrapPage" },
        [_vm._t("default"), _c("div", { staticClass: "leftBorder" })],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }